import '../sass/main.scss';

import $ from 'jquery';

// Expose jQuery globally for legacy scripts and any inline page scripts.
window.$ = window.jQuery = $;

import './formValidate.js';
import './lazyload_thumbs.js';
import './modal.js';
import './preview.js';
